import { createAsyncThunk } from '@reduxjs/toolkit';
import { useCustomAxios } from '../../shared/lib/customAxios';

export const createApprovalFlow = createAsyncThunk(
  'user/approval',
  async (reqBody: any) => {
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(
        '/order/party/createApprovalFlow',
        reqBody
      );
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return error.response.data;
    }
  }
);

export const getApprovalFlow = createAsyncThunk(
  "user/approvalFlow", 
  async () => {
    const { axiosGet } = useCustomAxios();
    try{
      const response = await axiosGet('/order/party/approvalFlow');
      return { data: response.data, status: response.status };
    }
    catch(error : any) {
      return error.response.data;
    }
  }
)
